import { OxGristEditor } from './ox-grist-editor.js'
import { customElement } from 'lit/decorators.js'
import { html } from 'lit'

@customElement('ox-grist-editor-month')
export class OxGristEditorMonth extends OxGristEditor {
  get editorTemplate() {
    return html` <input type="month" .value=${this.value} /> `
  }
}
